// ----------------------------------------------------------------------

const COLOR_PALETTE = [
  '#FF5733', // Red-Orange
  '#33FF57', // Green
  '#3357FF', // Blue
  '#FF33F0', // Pink-Purple
  '#F0FF33', // Yellow-Green
  '#33FFF0', // Cyan
  '#FF8333', // Orange
  '#8333FF', // Purple
  '#33FF83', // Light Green
  '#FF3383', // Magenta
  '#83FF33', // Lime Green
  '#3383FF', // Sky Blue
  '#FFD700', // Gold
  '#ADFF2F', // Green Yellow
  '#40E0D0', // Turquoise
  '#DA70D6', // Orchid
  '#FF6347', // Tomato
  '#7B68EE', // Medium Slate Blue
  '#00CED1', // Dark Turquoise
  '#FF4500', // Orange Red
];

function getAvatarColor(name) {
  if (!name) return COLOR_PALETTE[0]; // Default if no name

  let sumCharCodes = 0;
  for (let i = 0; i < name.length; i++) {
    sumCharCodes += name.charCodeAt(i);
  }
  const index = sumCharCodes % COLOR_PALETTE.length;
  return COLOR_PALETTE[index];
}

export default function createAvatar(name) {
  return {
    name: name ? name.charAt(0).toUpperCase() : '',
    color: getAvatarColor(name), // This will now return a hex string
  };
}